module.exports = __webpack_public_path__ + "static/media/photo262.0de5fe29.jpg";